export const render = async () => {
  const { init } = await import('./app');

  init();
}

render().then(() => {});